import React from "react";

import Header from "./components/Header";
import Nav from "./components/Nav";
import About from "./components/About";
import Footer from "./components/Footer";
import Projects from "./Projects";

function App() {
  return (
    <>
      <Nav />
      <Header />
      <About />
      <Projects />
      <Footer />
    </>
  );
}

export default App;
